import React, { useEffect } from 'react';

const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, { app: 'find_my_lead_magnet', ...params });
  }
};

function Results({ recommendations, email }) {

  useEffect(() => {
    if (recommendations) {
      trackEvent('strategies_viewed', { strategy_count: 3 });
    }
  }, [recommendations]);

  const downloadResults = () => {
    if (!recommendations) return;
    trackEvent('results_downloaded');
    let text = 'YOUR STRATEGIC LEAD MAGNET PLAN\n';
    text += 'by Designer of Content | designerofcontent.com\n';
    text += '='.repeat(50) + '\n\n';
    recommendations.forEach((rec, i) => {
      text += `Suggestion ${i + 1}: ${rec.name}\n`;
      text += `Credits: ${rec.credits}\n`;
      text += '-'.repeat(40) + '\n';
      text += `The Strategy: ${rec.strategy}\n\n`;
      text += `The Concept: ${rec.concept}\n\n`;
      text += `Next Step: ${rec.nextStep}\n\n`;
      text += '='.repeat(50) + '\n\n';
    });
    text += 'READY TO BUILD YOUR LEAD MAGNET?\n\n';
    text += 'Build My Leads creates professional lead magnets fast -- no design skills needed.\n\n';
    text += 'https://buildmyleads-ca05a.web.app/pricing.html\n';
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'my-lead-magnet-plan.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  if (!recommendations) {
    return (
      <div className="results-container">
        <div className="results-header">
          <h2>Building Your Lead Magnet Strategy...</h2>
          <div style={{ marginTop: '2rem', fontSize: '1.1rem', lineHeight: '2' }}>
            <p>Analyzing your business type...</p>
            <p>Matching your audience temperature...</p>
            <p>Selecting the best formats from the Credit Store...</p>
            <p style={{ marginTop: '1.5rem', color: '#ffd700', fontWeight: '600' }}>Almost there! This takes about 20-30 seconds.</p>
          </div>
        </div>
      </div>
    );
  }

  const creditColors = {
    1: '#ffd700',
    2: '#ffffff',
    3: '#c77afa'
  };

  return (
    <div className="results-container">
      <div className="results-header">
        <h2>Your Strategic Lead Magnet Plan</h2>
        <p>Based on your business and audience, here are the 3 lead magnet types that will work best for you:</p>
      </div>

      {recommendations.map((rec, index) => (
        <div key={index} className="recommendation-card">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '0.75rem' }}>
            <h3 style={{ margin: 0 }}>Suggestion {index + 1}: {rec.name}</h3>
            {rec.credits && (
              <span style={{
                background: 'rgba(255, 215, 0, 0.1)',
                border: `1px solid ${creditColors[rec.credits] || '#ffd700'}`,
                color: creditColors[rec.credits] || '#ffd700',
                padding: '0.25rem 0.75rem',
                borderRadius: '20px',
                fontSize: '0.85rem',
                fontWeight: '600',
                whiteSpace: 'nowrap'
              }}>
                {rec.credits} Credit{rec.credits > 1 ? 's' : ''}
              </span>
            )}
          </div>

          <p style={{ color: '#ffd700', fontWeight: '600', marginBottom: '0.5rem' }}>The Strategy:</p>
          <p style={{ marginBottom: '1rem' }}>{rec.strategy}</p>

          <p style={{ color: '#ffd700', fontWeight: '600', marginBottom: '0.5rem' }}>The Concept:</p>
          <p style={{ marginBottom: '1rem' }}>{rec.concept}</p>

          <div style={{
            marginTop: '1.25rem',
            padding: '0.85rem 1rem',
            backgroundColor: 'rgba(255, 215, 0, 0.08)',
            borderLeft: '3px solid #ffd700',
            borderRadius: '4px',
            fontSize: '0.95rem'
          }}>
            <strong>Next Step:</strong> {rec.nextStep}
          </div>
        </div>
      ))}

      {/* Download Button */}
      <div style={{ textAlign: 'center', margin: '2rem 0 1rem' }}>
        <button
          onClick={downloadResults}
          style={{
            background: 'rgba(255, 215, 0, 0.15)',
            border: '2px solid #ffd700',
            color: '#ffd700',
            padding: '0.85rem 2rem',
            borderRadius: '10px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Save My Results (Download)
        </button>
        <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', opacity: 0.7 }}>
          Download a copy so you don't lose your plan
        </p>
      </div>

      {/* Next Step Card */}
      <div style={{
        marginTop: '2rem',
        borderRadius: '16px',
        border: '2px solid #ffd700',
        overflow: 'hidden',
      }}>
        {/* Label bar */}
        <div style={{
          background: '#ffd700',
          padding: '0.5rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <span style={{ fontSize: '0.75rem', fontWeight: '800', letterSpacing: '0.1em', color: '#000000', textTransform: 'uppercase' }}>Your Next Step</span>
        </div>

        {/* Card body */}
        <div style={{
          background: '#111111',
          padding: '2rem 2rem 2.5rem',
          textAlign: 'center'
        }}>
          {/* Price badge */}
          <div style={{
            display: 'inline-block',
            background: 'rgba(255, 215, 0, 0.12)',
            border: '1px solid #ffd700',
            color: '#ffd700',
            borderRadius: '30px',
            padding: '0.35rem 1.1rem',
            fontSize: '0.85rem',
            fontWeight: '700',
            marginBottom: '1.25rem',
            letterSpacing: '0.03em'
          }}>
            From $97 &mdash; lifetime access, no subscription
          </div>

          <h3 style={{ fontSize: '1.6rem', fontWeight: '800', color: 'white', marginBottom: '0.75rem', lineHeight: '1.3' }}>
            You know what to build.<br />Now let us build it for you.
          </h3>

          <p style={{ fontSize: '1rem', color: '#cccccc', lineHeight: '1.7', maxWidth: '480px', margin: '0 auto 1.75rem' }}>
            Build My Leads takes your lead magnet plan and turns it into a professionally designed, ready-to-use file -- delivered to your inbox within 24 hours. No design skills, no software, nothing to figure out.
          </p>

          <a
            href="https://buildmyleads-ca05a.web.app"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('next_step_clicked', { destination: 'bml_landing' })}
            style={{
              display: 'inline-block',
              background: '#ffd700',
              color: '#000000',
              padding: '1rem 2.5rem',
              borderRadius: '10px',
              fontSize: '1.1rem',
              fontWeight: '700',
              textDecoration: 'none',
              transition: 'opacity 0.2s'
            }}
            onMouseOver={e => e.currentTarget.style.opacity = '0.88'}
            onMouseOut={e => e.currentTarget.style.opacity = '1'}
          >
            Build My Lead Magnet →
          </a>

          <p style={{ marginTop: '0.85rem', fontSize: '0.8rem', color: '#666666' }}>
            One-time payment. We design it. You get the file.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Results;
